export default function HowItWorks() {
  const steps = [
    {
      step: "01",
      icon: "ri-search-line",
      title: "Znajdź produkt",
      desc: "Przeglądaj kategorie w Kakobuy Spreadsheet i znajdź interesujące Cię produkty spośród setek starannie wyselekcjonowanych pozycji.",
    },
    {
      step: "02",
      icon: "ri-scales-line",
      title: "Porównaj informacje",
      desc: "Sprawdź szczegóły, porównaj ceny i wybierz najlepszą ofertę korzystając z uporządkowanych danych w arkuszu.",
    },
    {
      step: "03",
      icon: "ri-external-link-line",
      title: "Przejdź do głównej strony",
      desc: "Kliknij link i przejdź bezpośrednio do kaspreadsheet.com, aby sfinalizować zakup wybranego produktu.",
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10 max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-semibold rounded-full mb-4">
            Jak to działa
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Proste kroki do <span className="italic text-primary-500">lepszych zakupów</span>
          </h2>
        </div>

        <div className="flex flex-col md:flex-row items-start gap-6">
          {steps.map((s, idx) => (
            <div key={idx} className="flex-1 flex flex-col items-center text-center relative">
              <div className="w-16 h-16 rounded-2xl bg-accent-100 flex items-center justify-center mb-4 relative z-10">
                <i className={`${s.icon} text-2xl text-accent-600`}></i>
              </div>
              <span className="text-xs font-bold text-accent-500 mb-2">Krok {s.step}</span>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{s.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed max-w-xs">{s.desc}</p>

              {idx < steps.length - 1 && (
                <>
                  <div className="hidden md:block absolute top-8 left-[60%] w-full h-px bg-accent-200 z-0"></div>
                  <div className="hidden md:block absolute top-8 right-0 w-6 h-6 flex items-center justify-center z-10" style={{ right: '-12px' }}>
                    <i className="ri-arrow-right-s-line text-accent-400 text-lg"></i>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}